// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn__reset-password[data-v-55114615]{color:#fff;background-color:#4191ff;border-color:#4191ff;border:2px solid #4191ff;box-shadow:0 3.52px 8.4px rgba(65,145,255,.4),0 1px 6.16px rgba(65,145,255,.54);border-radius:3.2px}.form-control.is-invalid[data-v-55114615],.form-control.is-valid[data-v-55114615]{background-image:none!important}", ""]);
// Exports
module.exports = exports;
